export function clearSelection() {
  window.getSelection()?.removeAllRanges();
}
